import {materialState} from "../../state";

const FormatMaterialsData = (materialSets) => {
  /*
      ---------------------------------------------------------------------------
      materialSets
  */
  materialState.mainMaterialSets = materialSets;
  
};

export default FormatMaterialsData;
